import { z } from "zod";
import {
    DEFAULT_MAP_APPEARANCE_MODE,
    DEFAULT_MAP_STYLE_OVERRIDE,
    type MapAppearanceMode,
    type MapStyleOverride,
} from "../../../types/MapStyle";
import { definePersistedSlice } from "../runtime/definePersistedSlice";

/** Zod schema for map appearance and basemap style override. */
const MapPrefsSchema = z.object( {
    "appearanceMode": z.enum( [ "light", "dark", "auto" ] ).
        catch( DEFAULT_MAP_APPEARANCE_MODE ).
        default( DEFAULT_MAP_APPEARANCE_MODE ),
    "styleOverride": z.enum( [ "default", "hybrid", "legacy" ] ).
        catch( DEFAULT_MAP_STYLE_OVERRIDE ).
        default( DEFAULT_MAP_STYLE_OVERRIDE ),
} );

/** Map UI preferences (theme mode + style preset). */
export type MapPrefs = {
    "appearanceMode": MapAppearanceMode;
    "styleOverride":  MapStyleOverride;
};

/** Parsed defaults aligned with `MapStyle` module constants. */
export const MAP_PREFS_DEFAULT: MapPrefs = MapPrefsSchema.parse( {} );

/** Persisted slice: map light/dark/auto and basemap override. */
export const mapPrefsSlice = definePersistedSlice<MapPrefs>( {
    "key":            "mapPrefs",
    "currentVersion": 1,
    "storage":        "preferences",
    "eager":          true,
    "schema":         MapPrefsSchema,
    "default":        () => MAP_PREFS_DEFAULT,
    "migrations":     {},
} );
